import { render, staticRenderFns } from "./order-update.vue?vue&type=template&id=17bf9464&scoped=true&"
import script from "./order-update.vue?vue&type=script&lang=js&"
export * from "./order-update.vue?vue&type=script&lang=js&"
import style0 from "./order-update.vue?vue&type=style&index=0&id=17bf9464&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf9464",
  null
  
)

export default component.exports